module.exports = __webpack_public_path__ + "img/_ABS9718(1).3b0ca9e2.jpg";